// @flow
import { hot } from "react-hot-loader"

/**
 * Wrapper for React Hot Loader that safely handles the module object
 * for ES module compatibility in webpack 5
 */
const hotWrapper = component => {
  // In development, try to use hot reloading if available
  if (process.env.NODE_ENV === "development") {
    // Check if module.hot is available and not null
    if (typeof module !== "undefined" && module.hot) {
      return hot(module)(component)
    }
  }

  // In production or when HMR is not available, return component as-is
  return component
}

export { hotWrapper }
export default hotWrapper
